import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { TASKS_LIST_QUERY_KEY } from '../types/common/queryKeys';
import { TASK_CHANGED_EVENT, TASK_CREATED_EVENT } from '../types/common/taskDrawerEvents';

export const useInvalidateTasksOnDrawerEvents = (): void => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const handler = () => {
      queryClient.invalidateQueries([TASKS_LIST_QUERY_KEY]);
      queryClient.invalidateQueries(['RetrieveTasks']);
    };
    window.addEventListener(TASK_CREATED_EVENT, handler);
    window.addEventListener(TASK_CHANGED_EVENT, handler);

    return () => {
      window.removeEventListener(TASK_CREATED_EVENT, handler);
      window.removeEventListener(TASK_CHANGED_EVENT, handler);
    };
  }, [queryClient]);
};
